import axios from "axios";
// import store from "../store";
// import { GET_AUTH_DATA, SIGNIN_USER_SUCCESS } from "../store/mutation-types";
// import { refreshAllToken } from "./auth";
// import router from "../router";

export const baseAxios = () => {
  let token = localStorage.getItem("auth_access");
  return axios.create({
    baseURL: "https://cloud-api.talashnet.com",
    // baseURL: "http://192.168.1.102:8082",
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `bearer ${token}`
    }
  });
};
// const axiosInterceptor = axios.create({
//   baseURL: "http://asp.cv9.ir",
//   headers: {
//     "Content-type": "application/json",
//     "Access-Control-Allow-Origin": "*"
//   }
// });
// axiosInterceptor.interceptors.request.use(
//   config => {
//     ;
//     const token = localStorage.getItem("auth_access");
//     if (token) {
//       config.headers["Authorization"] = "Bearer " + token;
//     }
//     return config;

//     // const authData = store.getters["auth/" + GET_AUTH_DATA];
//     // if (authData == null) {
//     //   return config;
//     // }
//     // config.headers.common[
//     //   "Authorization"
//     // ] = `bearer ${authData.authAccessToken}`;
//     // ;
//     // return config;
//   },
//   error => {
//     ;
//     Promise.reject(error);
//   }
// );
// axiosInterceptor.interceptors.request.use(
//   response => {
//     return response;
//   },
//   async error => {
//     const originalRequest = error.config;
//     ;
//     if (
//       error.response.status === 401 &&
//       originalRequest.url === "http://asp.cv9.ir/auth/api/v1.0/refresh"
//     ) {
//       router.push("/login");
//       return Promise.reject(error);
//     }
//     ;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       const authData = store.getters["auth/" + GET_AUTH_DATA];

//       const [error, data] = await refreshAllToken({
//         accessToken: authData.accessToken,
//         refreshToken: authData.refreshToken
//       });
//       ;
//       if (!error && data.apiStatus === 200) {
//         store.commit("auth/" + SIGNIN_USER_SUCCESS, data.apiData);
//         axiosInterceptor.defaults.headers.common[
//           "Authorization"
//         ] = `bearer ${data.apiData.accessToken}`;
//         return axiosInterceptor(error.config);
//       }
//     } else {
//       ;
//       return Promise.reject(error);
//     }
//   }

// let isAuthenticated = store.getters["auth/" + IS_TOKEN_ALIVE];
// ;
// if (isAuthenticated) {
//   ;
//   config.headers.common[
//     "Authorization"
//   ] = `Bearer ${authData.authAccessToken}`;
//   return config;
// } else {
//   ;
//   refreshAllToken({
//     accessToken: authData.authAccessToken,
//     refreshToken: authData.authRefreshToken
//   }).then(
//     response => {
//       store.commit("auth/" + SIGNIN_USER_SUCCESS, {
//         accessToken: response.accessToken,
//         refreshToken: response.refreshToken,
//         expiresIn: response.expiresIn
//       });
//       axiosInterceptor(config);
//     },
//     err => {
//       axiosInterceptor(config);
//     }
//   );
// }
// );
// export default axiosInterceptor;
